import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ 'input' ]

  word(e) {
    this.inputTarget.value = e.target.text
  }
}
